<template>
    <div class="cart-total">
        <p>{{ $t( 'cart.money_back' ) }}</p>
        <button
        ga-label="Cart confirm(subscribe)"
        @click="subscribe"
        :class="[loading || disabled ? 'disabled' : '']">{{ button }}</button>
    </div>
</template>

<script>
export default {

    props: {

        loading: Boolean,
        button: String,
        disabled: Boolean

    },
    mounted () {

        $( 'body' ).addClass( 'has-cart-total' );

    },
    destroyed () {

        $( 'body' ).removeClass( 'has-cart-total' );

    },
    methods: {

        subscribe () {

            if ( !this.loading && !this.disabled ) {

                this.$emit( 'subscribe' );

            }

        }

    }

};
</script>

<style lang="less" scoped>
.cart-total{
    display: none;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    color: #555;
    z-index: 2;
    @media @mobile{
        display: block;
    }
}
.cart-total>p{
    line-height: 0.5rem;
    font-weight: 300;
    font-size: 0.24rem;
}
.content{
    border-top: 1px solid #e3e3e3;
    align-items: center;
    p{
        flex-grow: 1;
        font-size: 0.24rem;
        font-weight: 300;
        color: #666;
        .red{
            font-weight: 400;
            font-size: 0.33rem;
            color: #CC442A;
        }
        span{
            vertical-align: middle;
        }
    }
}
button{
    line-height: 1rem;
    height: 1rem;
    box-sizing: border-box;
    color: #fff;
    font-weight: 500;
    font-size: 0.33rem;
    padding: 0 0.6rem;
    display: block;
    background: linear-gradient(150deg, #eb3349, #f45c43);
    border: none;
    width: 100%;
    &.disabled{
        background: #f7f7f7;
        color: #ccc;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/cartTotal.vue